import * as Yup from 'yup';

export const nameAndImage = Yup.object({
  name: Yup.string().required(),
  imageType: Yup.string().required(),
  customImageData: Yup.mixed<File>().optional(),
});
